import { useQueryClient } from "@tanstack/react-query";
import { useState } from "react";
import { Button, Col, Form, Modal } from "react-bootstrap";
import { useForm } from "react-hook-form";
import LoadingButton from "../../components/Loading/LoadingButton";
import usePDFDownload from "../../hooks/usePDFDownload";

export default function PreOrderCodeCreate() {
  const [showModal, setShowModal] = useState(false);
  const queryClient = useQueryClient();

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const { isPending, mutate } = usePDFDownload({
    url: "/totalpost/v1/preOrderCode/create",
    onSuccess: () => {
      setShowModal(false);
      queryClient.refetchQueries({
        queryKey: ["PreOrderCodeList"],
      });
    },
  });

  return (
    <div>
      <Button variant="outline-primary" onClick={() => setShowModal(true)}>
        ایجاد کد
      </Button>

      <Modal show={showModal} centered size="lg">
        <form onSubmit={handleSubmit(values => mutate(values))}>
          <Modal.Header>ایجاد لیستی از کد پیش سفارش</Modal.Header>

          <Modal.Body className="d-flex flex-wrap bs row-gap-2">
            <Col xs={12} sm={6} xl={4}>
              <Form.Label>تعداد درخواستی</Form.Label>
              <Form.Select
                {...register("count", { required: "تعداد درخواستی الزامی" })}
              >
                <option value="10">10</option>
                <option value="20">20</option>
                <option value="50">50</option>
                <option value="100">100</option>
                <option value="200">200</option>
                <option value="500">500</option>
                <option value="1000">1000</option>
              </Form.Select>

              {errors.count && (
                <p className="text-danger fs-small">{errors.count.message}</p>
              )}
            </Col>

            <Col xs={12}>
              <Form.Label>نوع PDF درخواستی</Form.Label>
              <Form.Select
                {...register("type", { required: "نوع درخواستی الزامی" })}
              >
                <option value="1">
                  یک فایل و هر صفحه یک جفت کد پیش سفارش افقی
                </option>
                <option value="2">
                  یک فایل و هر صفحه یک جفت کد پیش سفارش عمودی
                </option>
              </Form.Select>

              {errors.type && (
                <p className="text-danger fs-small">{errors.type.message}</p>
              )}
            </Col>
          </Modal.Body>

          <Modal.Footer>
            <LoadingButton
              className="btn-success ms-auto"
              type="submit"
              center
              isLoading={isPending}
              title={isPending ? "در حال ایجاد" : "ایجاد"}
            />

            <Button
              disabled={isPending}
              variant="outline-danger"
              type="button"
              onClick={() => setShowModal(false)}
            >
              بستن
            </Button>
          </Modal.Footer>
        </form>
      </Modal>
    </div>
  );
}
